import { render, staticRenderFns } from "./TestPage.vue?vue&type=template&id=99dc5ac2&scoped=true"
import script from "./TestPage.vue?vue&type=script&lang=js"
export * from "./TestPage.vue?vue&type=script&lang=js"
import style0 from "./TestPage.vue?vue&type=style&index=0&id=99dc5ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dc5ac2",
  null
  
)

export default component.exports